import { useEffect, useState } from 'react';
import { Select } from '@etherisc/ui-kit';
import { CountryOption } from '../../config/countries/types';
import { getSupportedCountries } from '../../config/countries/index';

interface CountrySelectorProps {
  value: string;
  onChange: (countryCode: string) => void;
  disabled?: boolean;
  error?: string;
}

export function CountrySelector({ 
  value, 
  onChange, 
  disabled = false, 
  error 
}: CountrySelectorProps) {
  const [countries, setCountries] = useState<CountryOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        setIsLoading(true);
        // For now, use the local config. Later this could fetch from API
        const supportedCountries = getSupportedCountries();
        setCountries(supportedCountries);
      } catch (error) {
        console.error('Failed to load countries:', error);
        // Fallback to Zimbabwe only
        setCountries([{ code: 'ZW', name: 'Zimbabwe', enabled: true }]);
      } finally {
        setIsLoading(false);
      }
    };

    loadCountries();
  }, []);

  const options = countries
    .filter(country => country.enabled)
    .map(country => ({
      value: country.code,
      label: country.name,
    }));

  return (
    <Select
      label="Country"
      value={value}
      onValueChange={onChange}
      options={options}
      disabled={disabled || isLoading}
      error={error}
      placeholder={isLoading ? "Loading countries..." : "Select country"}
    />
  );
}